import { render, staticRenderFns } from "./SelectSectors.vue?vue&type=template&id=68973a4e&"
import script from "./SelectSectors.vue?vue&type=script&lang=js&"
export * from "./SelectSectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports